<div class="row justify-content-center align-items-center">
  <div class="col-12 col-xl-auto">
    <div class="d-flex mb-3 text-center justify-content-center">
      <h1 class="h4 m-0 text-colonial">Hola, ¿cómo podemos ayudarte?</h1>
    </div>
  </div>
</div>
<div class="row justify-content-center">
  <div class="col-12 col-lg" style="max-width: 800px">
    <ngb-carousel>
      @for (banner of banners; track $index) {
        <ng-template ngbSlide>
          <div
            class="picsum-img-wrapper rounded-3 overflow-hidden"
            (click)="
              goToLink(banner.acf.enlace_del_banner_portada_oficina_virtual)
            "
          >
            <img
              [src]="banner.acf.banner_portada_oficina_virtual_img"
              alt=""
              class="w-100 object-fit-contain"
              style="max-height: 400px"
            />
          </div>
        </ng-template>
      }
    </ngb-carousel>
  </div>
</div>

<div class="row justify-content-center">
  <div class="col-auto">
    <strong class="my-3 d-flex fw-normal text-muted"
      >¿Necesitas asistencia?</strong
    >
  </div>
</div>
<div
  class="row g-2 row-cols-1 row-cols-lg-3 justify-content-center app-nav mx-auto"
  style="max-width: 990px"
>
  <div class="col">
    <a
      class="position-relative item-link-services-reportar-accidente border-0 bg-white d-flex align-items-center gap-2 text-decoration-none text-dark rounded-4 shadow-sm p-2 p-md-3"
      href="/claims/create"
    >
      <span
        class="material-symbols-outlined border-2 border rounded-circle d-flex"
        style="
          color: #e93b24;
          border-color: #e93b24 !important;
          min-width: 50px;
          min-height: 50px;
          text-align: center;
          align-items: center;
          justify-content: center;
          font-size: 32px;
        "
        >car_crash</span
      >
      <span class="d-flex flex-column small"
        >Reporta en línea un <strong> Accidente o Siniestro</strong></span
      >
    </a>
  </div>
  <div class="col">
    <a
      class="position-relative item-link-services-asistencia-vial border-0 bg-white d-flex align-items-center gap-2 text-decoration-none text-dark rounded-4 shadow-sm p-2 p-md-3"
      href="/cranes"
    >
      <span
        class="material-symbols-outlined border-2 border rounded-circle d-flex"
        style="
          color: #0464bd;
          border-color: #0464bd !important;
          min-width: 50px;
          min-height: 50px;
          text-align: center;
          align-items: center;
          justify-content: center;
          font-size: 32px;
        "
        >auto_towing</span
      >
      <span class="d-flex flex-column small"
        >Solicita en línea tu <strong>Asistencia Vial</strong></span
      >
    </a>
  </div>
  <div class="col">
    <a
      class="position-relative item-link-services-asistencia-vial border-0 bg-white d-flex align-items-center gap-2 text-decoration-none text-dark rounded-4 shadow-sm p-2 p-md-3"
      href="https://www.siguelotu.com.do/"
      target="_blank"
    >
      <span
        class="border-2 border rounded-circle d-flex"
        style="
          color: #89181b !important;
          border-color: #89181b !important;
          min-width: 50px;
          min-height: 50px;
          text-align: center;
          align-items: center;
          justify-content: center;
          font-size: 32px;
        "
      >
        <svg
          width="30"
          height="auto"
          viewBox="0 0 60 56"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M28 0C35.0152 0 41.4277 2.58002 46.3408 6.84277L41.374 11.8086C37.7417 8.80488 33.0816 7 28 7C16.402 7 7 16.402 7 28C7 39.598 16.402 49 28 49C39.598 49 49 39.598 49 28C49 27.6114 48.9886 27.2252 48.9678 26.8418L55.0518 20.7578C55.6687 23.0681 56 25.4953 56 28C56 43.464 43.464 56 28 56C12.536 56 0 43.464 0 28C0 12.536 12.536 0 28 0Z"
            fill="#89181B"
          />
          <path
            d="M50.9648 6.96251C52.9175 5.00989 56.0825 5.00989 58.0352 6.96251C59.9878 8.91513 59.9878 12.0802 58.0352 14.0328L30.791 41.277C28.3368 43.7312 24.3187 43.5979 22.0332 40.986L12.2373 29.7906C10.419 27.7126 10.6292 24.5534 12.707 22.735C14.7851 20.9167 17.9442 21.1268 19.7627 23.2047L26.7432 31.1832L50.9648 6.96251Z"
            fill="#8E8E8E"
          />
        </svg>
      </span>
      <span class="d-flex flex-column small"
        >Sigue paso a paso tu <strong>Reclamación</strong></span
      >
    </a>
  </div>
</div>
<div class="row justify-content-center">
  <div class="col-auto">
    <strong class="my-3 d-flex fw-normal text-muted"
      >Cotiza o adquiere un nuevo seguro</strong
    >
  </div>
</div>
<div
  class="row g-2 g-lg-3 g-xl-4 row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 row-cols-xl-5 row-cols-xxl-5 justify-content-center app-nav mx-auto"
  style="max-width: 1240px"
>
  <div class="col">
    <div
      class="card transition-03s product-colonial-vital rounded-5 border border-light shadow item-product-card position-relative bg-gradient-1"
    >
      <!-- Indicador dinámico con color -->
      <div
        class="indicator transition-03s position-absolute mx-auto start-0 end-0 rounded-bottom-4 rounded-top-0 bg-light border-bottom border-start border-end"
        style="width: 70px; height: 14px; background-color: #ce343c"
      ></div>

      <a
        class="card-body transition-03s text-center text-decoration-none p-4"
        href="https://colonialvital.com.do/"
        target="_blank"
      >
        <!-- Título dinámico -->
        <header
          class="mx-auto d-flex flex-column justify-content-center align-items-center"
          style="max-width: 80%"
        >
          <span class="material-symbols-outlined">person_heart</span>
          <h2
            class="fs-6 lh-1 py-2 m-0 fw-light text-secondary"
            style="min-height: 54px"
          >
            <small class="">Protege a quienes más quieres</small>
          </h2>
          <hr style="width: 50px" class="mx-auto mb-0 mt-0 border" />
        </header>

        <!-- Imagen dinámica -->
        <figure class="mb-0 mt-0 d-flex flex-column transition-03s">
          <img
            src="../../../../../assets/img/colonial-vital-la-colonial.png"
            alt="Seguro de &lt;br /&gt; &lt;strong&gt;personas&lt;/strong&gt;"
            class="img-fluid h-100 object-fit-contain"
          />
        </figure>

        <!-- Botón dinámico -->
        <footer>
          <p class="lh-sm small small m-0 fw-light text-secondary">
            Seguro de <br />
            <strong>personas</strong>
          </p>
          <button
            class="d-none btn btn-light border bg-white btn-sm text-nowrap lh-0 mx-auto px-4 py-2 rounded-pill gap-1 align-items-center justify-content-center"
            target="_blank"
          >
            <span class="fw-semibold">Cotiza ahora</span>
            <span
              class="material-symbols-outlined text-muted"
              style="width: 10px"
              >chevron_right</span
            >
          </button>
        </footer>
      </a>
    </div>
  </div>
  <div class="col">
    <div
      class="card transition-03s product-emprende-seguro rounded-5 border border-light shadow item-product-card position-relative bg-gradient-1"
    >
      <!-- Indicador dinámico con color -->
      <div
        class="indicator transition-03s position-absolute mx-auto start-0 end-0 rounded-bottom-4 rounded-top-0 bg-light border-bottom border-start border-end"
        style="width: 70px; height: 14px; background-color: #26648b"
      ></div>

      <a
        class="card-body transition-03s text-center text-decoration-none p-4"
        href="http://emprendesegurolacolonial.com.do/"
        target="_blank"
      >
        <!-- Título dinámico -->
        <header
          class="mx-auto d-flex flex-column justify-content-center align-items-center"
          style="max-width: 80%"
        >
          <span class="material-symbols-outlined">work</span>
          <h2
            class="fs-6 lh-1 py-2 m-0 fw-light text-secondary"
            style="min-height: 54px"
          >
            <small> Protege tu esfuerzo</small>
          </h2>
          <hr style="width: 50px" class="mx-auto mb-0 mt-0 border" />
        </header>

        <!-- Imagen dinámica -->
        <figure class="mb-0 mt-0 d-flex flex-column transition-03s">
          <img
            src="../../../../../assets/img/emprendeseguro.png"
            alt="Seguro para &lt;br /&gt; &lt;strong&gt;tu negocio&lt;/strong&gt;"
            class="img-fluid h-100 object-fit-contain"
          />
        </figure>

        <!-- Botón dinámico -->
        <footer>
          <p class="lh-sm small small m-0 fw-light text-secondary">
            Seguro para <br />
            <strong>tu negocio</strong>
          </p>
          <button
            class="d-none btn btn-light border bg-white btn-sm text-nowrap lh-0 mx-auto px-4 py-2 rounded-pill gap-1 align-items-center justify-content-center"
            target="_blank"
          >
            <span class="fw-semibold">Cotiza ahora</span>
            <span
              class="material-symbols-outlined text-muted"
              style="width: 10px"
              >chevron_right</span
            >
          </button>
        </footer>
      </a>
    </div>
  </div>
  <div class="col">
    <div
      class="card transition-03s product-armalo-tu rounded-5 border border-light shadow item-product-card position-relative bg-gradient-1"
    >
      <!-- Indicador dinámico con color -->
      <div
        class="indicator transition-03s position-absolute mx-auto start-0 end-0 rounded-bottom-4 rounded-top-0 bg-light border-bottom border-start border-end"
        style="width: 70px; height: 14px; background-color: #fb7900"
      ></div>

      <a
        class="card-body transition-03s text-center text-decoration-none p-4"
        href="https://www.armalotu.com.do/"
        target="_blank"
      >
        <!-- Título dinámico -->
        <header
          class="mx-auto d-flex flex-column justify-content-center align-items-center"
          style="max-width: 80%"
        >
          <span class="material-symbols-outlined">directions_car</span>
          <h2
            class="fs-6 py-2 lh-1 m-0 fw-light text-secondary"
            style="min-height: 54px"
          >
            <small>Protege el vehículo que te mueve</small>
          </h2>
          <hr style="width: 50px" class="mx-auto mb-0 mt-0 border" />
        </header>

        <!-- Imagen dinámica -->
        <figure class="mb-0 mt-0 d-flex flex-column transition-03s">
          <img
            src="../../../../../assets/img/armalotu.png"
            alt="Seguro para &lt;br /&gt; &lt;strong&gt;tu vehículo&lt;/strong&gt;"
            class="img-fluid h-100 object-fit-contain"
          />
        </figure>

        <!-- Botón dinámico -->
        <footer>
          <p class="lh-sm small small m-0 fw-light text-secondary">
            Seguro para <br />
            <strong>tu vehículo</strong>
          </p>
          <button
            class="d-none btn btn-light border bg-white btn-sm text-nowrap lh-0 mx-auto px-4 py-2 rounded-pill gap-1 align-items-center justify-content-center"
            target="_blank"
          >
            <span class="fw-semibold">Cotiza ahora</span>
            <span
              class="material-symbols-outlined text-muted"
              style="width: 10px"
              >chevron_right</span
            >
          </button>
        </footer>
      </a>
    </div>
  </div>
  <div class="col">
    <div
      class="card transition-03s product-hogar-seguro rounded-5 border border-light shadow item-product-card position-relative bg-gradient-1"
    >
      <!-- Indicador dinámico con color -->
      <div
        class="indicator transition-03s position-absolute mx-auto start-0 end-0 rounded-bottom-4 rounded-top-0 bg-light border-bottom border-start border-end"
        style="width: 70px; height: 14px; background-color: #e9725f"
      ></div>

      <a
        class="card-body transition-03s text-center text-decoration-none p-4"
        href="https://www.hogarseguro.do/"
        target="_blank"
      >
        <!-- Título dinámico -->
        <header
          class="mx-auto d-flex flex-column justify-content-center align-items-center"
          style="max-width: 80%"
        >
          <span class="material-symbols-outlined">home_work</span>
          <h2
            class="fs-6 py-2 lh-1 m-0 fw-light text-secondary"
            style="min-height: 54px"
          >
            <small>Protege tu hogar pase lo que pase</small>
          </h2>
          <hr style="width: 50px" class="mx-auto mb-0 mt-0 border" />
        </header>

        <!-- Imagen dinámica -->
        <figure class="mb-0 mt-0 d-flex flex-column transition-03s">
          <img
            src="../../../../../assets/img/hogarseguro.png"
            alt="Asegura tu &lt;br /&gt; &lt;strong&gt;vivienda&lt;/strong&gt;"
            class="img-fluid h-100 object-fit-contain"
          />
        </figure>

        <!-- Botón dinámico -->
        <footer>
          <p class="lh-sm small small m-0 fw-light text-secondary">
            Asegura tu <br />
            <strong>vivienda</strong>
          </p>
          <button
            class="d-none btn btn-light border bg-white btn-sm text-nowrap lh-0 mx-auto px-4 py-2 rounded-pill gap-1 align-items-center justify-content-center"
            target="_blank"
          >
            <span class="fw-semibold">Cotiza ahora</span>
            <span
              class="material-symbols-outlined text-muted"
              style="width: 10px"
              >chevron_right</span
            >
          </button>
        </footer>
      </a>
    </div>
  </div>
  <div class="col">
    <div
      class="card transition-03s product-viaja-seguro rounded-5 border border-light shadow item-product-card position-relative bg-gradient-1"
    >
      <!-- Indicador dinámico con color -->
      <div
        class="indicator transition-03s position-absolute mx-auto start-0 end-0 rounded-bottom-4 rounded-top-0 bg-light border-bottom border-start border-end"
        style="width: 70px; height: 14px; background-color: #26648b"
      ></div>

      <a
        class="card-body transition-03s text-center text-decoration-none p-4"
        href="https://www.viajaseguro.do/"
        target="_blank"
      >
        <!-- Título dinámico -->
        <header
          class="mx-auto d-flex flex-column justify-content-center align-items-center"
          style="max-width: 80%"
        >
          <span class="material-symbols-outlined">airplane_ticket</span>
          <h2
            class="fs-6 lh-1 py-2 m-0 fw-light text-secondary"
            style="min-height: 54px"
          >
            <small>Protege tus viajes pase lo que pase</small>
          </h2>
          <hr style="width: 50px" class="mx-auto mb-0 mt-0 border" />
        </header>

        <!-- Imagen dinámica -->
        <figure class="mb-0 mt-0 d-flex flex-column transition-03s">
          <img
            src="../../../../../assets/img/viajaseguro.png"
            alt="Asegura tu &lt;br /&gt; próximo &lt;strong&gt;viaje&lt;/strong&gt;"
            class="img-fluid h-100 object-fit-contain"
          />
        </figure>

        <!-- Botón dinámico -->
        <footer>
          <p class="lh-sm small small m-0 fw-light text-secondary">
            Asegura tu <br />
            próximo <strong>viaje</strong>
          </p>
          <button
            class="d-none btn btn-light border bg-white btn-sm text-nowrap lh-0 mx-auto px-4 py-2 rounded-pill gap-1 align-items-center justify-content-center"
            target="_blank"
          >
            <span class="fw-semibold">Cotiza ahora</span>
            <span
              class="material-symbols-outlined text-muted"
              style="width: 10px"
              >chevron_right</span
            >
          </button>
        </footer>
      </a>
    </div>
  </div>
</div>
<hr />
